<ion-button *ngIf="currentCognitoUser == null" (click)="logout()">{{
  _buttonText
}}</ion-button>
